import type { FaireProductEntity } from "../../entity_types/product";

export const p_qacktwqtsr: FaireProductEntity = {
  token: "p_qacktwqtsr",
  type: "product",
  name: "100 Customer Scratch-off Cards - Thank You Shop Small",
  brandName: "Inklings Paperie",
  imageUrl:
    "https://cdn.faire.com/fastly/1db8ffc0ba4b6eb97c4cc6ac55d5bad42e082aa7629e5423978073d277c1a207.jpeg",
  priceDollars: 50,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f4160b1a493577aac8e228eae13b1ee5ae85a4eeb0046abfcb064ca4329798ce.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
